import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { scroller } from 'react-scroll';
import ReactTooltip from '@huner2/react-tooltip';
import { getDateLabel, getNightsLabel } from '../../utilities/dealsHelper';
import { selectLocationDealsList } from '../locationDeals/locationDealsSlice';
import { selectDealsList } from '../dealsList/dealsListSlice';
import { selectDateFilter, specificDateSelected } from '../mainFilter/selectors';
// import { updateDatesFilter } from '../mainFilter/mainFilterSlice';
import { selectSearch } from '../mainFilter/searchSlice';
import { updateMainFilterModal } from '../mainFilter/mainFilterModalsSlice';
import abTesting from '../../services/abTesting';
import NonCachedOffer from '../locationDeals/NonCachedOffer';
import { setPreselectedDateType, toggleCustomize, toggleCustomizePanel } from '../customize-button/customizeButtonSlice';
import { CUSTOMIZE, DATE_TYPES } from '../../constants/constants';
import { isMobile } from '../../utilities/helpers';

export default function HotelSearchResult({ noResults }) {
  const dispatch = useDispatch();
  const { searchEngine } = useSelector((state) => state.mainFilter);
  const search = useSelector(selectSearch);
  const { staticDeal, selectedHotel } = useSelector((state) => state.userSearch);
  const { dealsList } = useSelector(selectDealsList);
  const deals = useSelector(selectDealsList);
  const { hotelPrices } = useSelector(selectLocationDealsList);
  const datesFilter = useSelector(selectDateFilter);
  const isSpecific = useSelector(specificDateSelected);
  const highlightedDeal = dealsList.find(item => +item.hotel.provider_hotel_id === +selectedHotel.hotelId);
  const cachedDealNotAvailable = !highlightedDeal && selectedHotel.hfHotelId;

  const dateLabel = getDateLabel(searchEngine.when);
  const nightsLabel = getNightsLabel(searchEngine.when);
  const dealItem = hotelPrices.offers.find(
    (item) => item.hotel.provider_hotel_id === staticDeal?.id
  );

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [deals, staticDeal, hotelPrices.pending]);

  const getLocationState = () => {
    if (isSpecific && !hotelPrices.error && hotelPrices.offers.length === 0) return 'pending';
    if (isSpecific && !hotelPrices.error && hotelPrices.pending) return 'pending';
    if (isSpecific && !hotelPrices.pending) {
      return getLocationPrice() ? 'available' : 'sold';
    }

    return 'default';
  };

  const onPickDatesClick = () => {
    if (abTesting.customizeButton && isMobile()) {
      dispatch(toggleCustomize(true));
      setTimeout(() => dispatch(toggleCustomizePanel(CUSTOMIZE.WHEN)), 0);
      dispatch(setPreselectedDateType(DATE_TYPES.SPECIFIC));
    } else {
      /* dispatch(updateDatesFilter({
        ...search,
        ...datesFilter,
        type: 'specific',
      })); */
      dispatch(updateMainFilterModal({ when: true }));
      scroller.scrollTo('scrollToResults', {
        delay: 100,
        offset: -100,
        smooth: true,
        duration: 1000,
      });
     
      setTimeout(() => {
        document.getElementById('specificDates')?.click();
      }, 1100);
    }
  }

  const getLocationPrice = () => dealItem ? dealItem.offer.price : null;

  if ((staticDeal?.id && !selectedHotel.hfHotelId && !deals.pending && !noResults) || (cachedDealNotAvailable && staticDeal?.id && !deals.pending && !noResults)) {
    return (
      <NonCachedOffer
        key={staticDeal.id}
        hotelItem={staticDeal}
        dateLabel={dateLabel}
        nightsLabel={nightsLabel}
        state={getLocationState()}
        photos={staticDeal.hotelPhotos || []}
        hotelName={staticDeal.text}
        dealItem={dealItem}
        onPickDatesClick={onPickDatesClick}
        selected
      />
    )
  }

  return null;
}
